import firebase from "firebase/app"

export const firebaseService = {
  async signUp(email, password, profile) {
    const res = await firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
    const userProfile = {
      ...profile,
      isAuth: false,
    }
    firebaseService.createUserProfile(res.user.uid, userProfile)
    return
  },
  signInWithEmailAndPassword(email, password) {
    return firebase.auth().signInWithEmailAndPassword(email, password)
  },
  signOut() {
    return firebase.auth().signOut()
  },
  sendEmailVerification() {
    firebase.auth().languageCode = "ja"
    return firebase.auth().currentUser.sendEmailVerification()
  },
  sendPasswordResetEmail(email) {
    firebase.auth().languageCode = "ja"
    return firebase.auth().sendPasswordResetEmail(email)
  },
  updateUserProfile(uid, userProfile) {
    return firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .set({
        ...userProfile,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      })
  },
  createUserProfile(uid, userProfile) {
    return firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .set({
        ...userProfile,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      })
  },
}
